import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcPauseFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 3.75a2 2 0 0 0-2 2v12.5a2 2 0 1 0 4 0V5.75a2 2 0 0 0-2-2M16 3.75a2 2 0 0 0-2 2v12.5a2 2 0 1 0 4 0V5.75a2 2 0 0 0-2-2"
  }));
}
var IcPauseFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcPauseFill));

export { IcPauseFill as I };
